export default {
  addOns: 'Tillägg',
  availability: 'Tillgänglighet',
  availabilityDaySelector: 'Väljare för tillgänglighetsdatum',
  unavailable: 'Ej tillgänglig',
  person: 'person',
  people: 'personer',
  reserveNow: 'Reservera nu',
  selectTime: 'Välj tid',
  select: 'Välj',
  reserve: 'Reservera',
  time: 'Tid',
  tier: 'Nivå',
  questions: 'Frågor',
  addToCart: 'Lägg i varukorg',
  checkout: 'Kassa',
  total: 'Totalt',
  whatsIncluded: 'Vad som ingår',
  showMore: 'Visa mer',
  showLess: 'Visa mindre',
  session: 'Session',
  viewDetails: 'Visa detaljer',
  findAvailability: 'Hitta tillgänglighet',
  loading: 'Laddar',
  capacity: 'Kapacitet',
  noAvailableSessionsOnThisDate: 'Inga tillgängliga sessioner på detta datum',
  noGroupAvailableOnThisDateAndTime:
    'Ingen {{groupTitle}} tillgänglig vid detta datum och tid',
  noCollectionFound: 'Ingen samling hittades!',
  noResourceGroupFound: 'Ingen resursgrupp hittades!',
  noData: 'Ingen data!',
  continue: 'Fortsätt',
  night: 'natt',
  nights: 'nätter',
  noAvailableSessionsForSelectedDates:
    'Vissa datum i ditt urval har inga tillgängliga sessioner. Vänligen välj andra datum.',
  from: 'från',
  dateRangeSelector: 'Väljare för datumintervall',
  priceTierRadioGroup: 'Väljare för prisnivå',
  startTime: 'Starttid',
  duration: 'Längd',
  lengthOfStay: 'Vistelsens längd',
  startDate: 'Startdatum',
  endDate: 'Slutdatum',
  selectDates: 'Välj datum',
  more: 'Fler',
  selectStartTime: 'Välj en starttid',
  endTime: 'Sluttid',
  selectEndTime: 'Välj en sluttid',
  morning: 'Förmiddag',
  afternoon: 'Eftermiddag',
  save: 'Spara',
  selectDuration: 'Välj en längd',
  forLength: 'för {{length}}',
  moreDates: '{{count}} fler',
  addDate: 'Lägg till datum',
  start: 'Start',
  end: 'Slut',
  pickupFrom: 'Upphämtning från',
  returnBy: 'Återlämning senast',
  day: 'dag',
  days: 'dagar',
  hour: 'timme',
  hours: 'timmar',
};
